module.exports = __webpack_public_path__ + "static/media/SING-UOW-SG.d19b5310.png";